import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/globals/App.css';
import Home from './components/pages/Home';
import About from './components/pages/About';
import Gallery from './components/pages/Gallery';
import Privacy from './components/pages/Privacy';
import Contact from './components/pages/Contact';
import Posts from './components/pages/Posts';
import Features from './components/features/Features';
import FeatureDetail from './components/features/FeatureDetail';
import CategoryFeatures from './components/features/CategoryFeatures';
import PostDetail from './components/posts/PostDetail';
import CategoryPosts from './components/posts/CategoryPosts';
import ScrollToTop from './components/layout/ScrollToTop';
import FloatingDock from './components/layout/FloatingDock';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/posts" element={<Posts />} />
          <Route path="/features" element={<Features />} />
          <Route path="/features/category/:category" element={<CategoryFeatures />} />
          <Route path="/features/:slug" element={<FeatureDetail />} />
          <Route path="/post/:slug" element={<PostDetail />} />
          <Route path="/:category" element={<CategoryPosts />} />
        </Routes>
        
        {/* Global FloatingDock that persists across all pages */}
        <FloatingDock />
      </div>
    </Router>
  );
}

export default App;
